import React from 'react';
import ReactMarkdown from 'react-markdown';
import { Box, Heading, Text, Link } from '@chakra-ui/react';

const ChakraMarkdown = ({ markdown }) => {
    return (
        <Box p={4} bg="gray.50" borderRadius="md">
            <ReactMarkdown
                components={{
                    h2: ({node, ...props}) => <Heading as="h2" size="lg" mt={4} mb={2} color="gray.700" {...props} />,
                    h3: ({node, ...props}) => <Heading as="h3" size="md" mt={4} mb={2} color="gray.600" {...props} />,
                    p: ({node, ...props}) => <Text mb={4} color="gray.600" {...props} />,
                    a: ({node, ...props}) => <Link color="blue.500" {...props} />,
                    ul: ({node, ...props}) => <Box as="ul" pl={6} {...props} />,  // Now native ul
                    li: ({node, ...props}) => <Box as="li" ml={4} {...props} />  // Now native li
                }}
            >
                {markdown}
            </ReactMarkdown>
        </Box>
    );
};

export default ChakraMarkdown;